import React from 'react';
import { FlexBox } from '@eltoro-ui/components';
import { CampaignModalContentProps } from 'Components/CampaignExamplesWidget/components/CampaignExamplesModal/components/CampaignModalContent';
import '../../../../CampaignExamplesModal.scss';

const labels = ['Sell Your Listing Faster', 'Virtual Just Listed/Just Sold'];

interface CreativesMobileContentProps extends Pick<CampaignModalContentProps, 'selectedLens'> {}

export default function CreativesMobileContent({ selectedLens }: CreativesMobileContentProps) {
  if (labels.includes(selectedLens.label))
    return (
      <FlexBox flexDirection="column" gap="2rem" alignItems="center">
        <FlexBox
          UNSAFE_className="creative-mobile-container"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <div className="img-wrapper">
            <img src={selectedLens.creatives['300-250']} alt="300-250" />
            <div className="creative-dimensions">300 x 250</div>
          </div>
        </FlexBox>
        <FlexBox
          UNSAFE_className="creative-mobile-container"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <div className="img-wrapper">
            <img src={selectedLens.creatives['300-250_1']} alt="300-250-1" />
            <div className="creative-dimensions">300 x 250</div>
          </div>
        </FlexBox>
        <FlexBox
          UNSAFE_className="creative-mobile-container"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <div className="img-wrapper">
            <img src={selectedLens.creatives['320-50']} alt="320-50" />
            <div className="creative-dimensions">320 x 50</div>
          </div>
        </FlexBox>
        <FlexBox
          UNSAFE_className="creative-mobile-container"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <div className="img-wrapper">
            <img src={selectedLens.creatives['320-100']} alt="320-100" />
            <div className="creative-dimensions">320 x 100</div>
          </div>
        </FlexBox>
        <FlexBox
          UNSAFE_className="creative-mobile-container"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <div className="img-wrapper">
            <img src={selectedLens.creatives['300-600']} alt="300-600" />
            <div className="creative-dimensions">300 x 600</div>
          </div>
        </FlexBox>
        <FlexBox
          UNSAFE_className="creative-mobile-container"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <div className="img-wrapper">
            <img src={selectedLens.creatives['160-600']} alt="160-600" />
            <div className="creative-dimensions">160 x 600</div>
          </div>
        </FlexBox>
      </FlexBox>
    );

  return (
    <FlexBox flexDirection="column" gap="2rem">
      <FlexBox
        UNSAFE_className="creative-mobile-container"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <div className="img-wrapper">
          <img src={selectedLens.creatives['728-90']} alt="728-90" />
          <div className="creative-dimensions">728 x 90</div>
        </div>
      </FlexBox>

      <FlexBox
        UNSAFE_className="creative-mobile-container"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <div className="img-wrapper">
          <img src={selectedLens.creatives['300-600']} alt="300-600" />
          <div className="creative-dimensions">300 x 600</div>
        </div>
      </FlexBox>

      <FlexBox
        UNSAFE_className="creative-mobile-container"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <div className="img-wrapper">
          <img src={selectedLens.creatives['320-100']} alt="320-100" />
          <div className="creative-dimensions">320 x 100</div>
        </div>
      </FlexBox>

      <FlexBox
        UNSAFE_className="creative-mobile-container"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <div className="img-wrapper">
          <img src={selectedLens.creatives['300-250']} alt="300-250" />
          <div className="creative-dimensions">300 x 250</div>
        </div>
      </FlexBox>

      <FlexBox
        UNSAFE_className="creative-mobile-container"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <div className="img-wrapper">
          <img src={selectedLens.creatives['300-250_1']} alt="300-250-1" />
          <div className="creative-dimensions">300 x 250</div>
        </div>
      </FlexBox>

      <FlexBox
        UNSAFE_className="creative-mobile-container"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <div className="img-wrapper">
          <img src={selectedLens.creatives['160-600']} alt="160-600" />
          <div className="creative-dimensions">160 x 600</div>
        </div>
      </FlexBox>
    </FlexBox>
  );
}
